import {mapActions, mapGetters} from 'vuex'

export const LINKS_TABLE_TYPES = Object.freeze({
  REVIEW_AND_COMMENTS: 'review-and-comments',
  QUICK_PREVIEW: 'quick-preview'
})

export const linkMixin = {
  computed: {
    ...mapGetters({
      'links': 'links/all',
      'reviewAndCommentsLinks': 'links/reviewAndCommentsLinks',
      'quickPreviewLinks': 'links/quickPreviewLinks'
    })
  },
  methods: {
    ...mapActions({
      'getLinks': 'links/getLinks',
      'setPagerData': 'links/setPagerData',
      'deleteLink': 'links/deleteLink',
      'refreshLink': 'links/refreshLink',
      'updateLink': 'links/updateLink',
      'setLinksSearchTerms': 'links/setLinksSearchTerms',
      'validateReviewClone': 'links/validateReviewClone'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/linkMixin.js